import {ConsumerSessionModel} from 'spotcharge-types';

/** Whether the user must complete set-basic-profile before using the app. */
export function needsBasicProfile(session: ConsumerSessionModel | null | undefined): boolean {
  if (!session) {
    return true;
  }
  return !session.profile.isProfileComplete || session.isNewAccount;
}
